import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListItem } from '@fs/zion-ui'
import { MenuMore } from '@fs/zion-icon'
import { disabledStatuses } from '../../../helpers'

export default function GenealogyTreeMenuAction({ menuButtonProps, onMenuClick, tree }) {
  const [t] = useTranslation()

  return (
    <ListItem.IconButton
      disabledDescription={t('tree-import.tree-menu-disable.description', {
        treeStatus: tree.treeStatus,
      })}
      disabled={disabledStatuses.includes(tree.treeStatus)}
      key={`menuOverlay ${tree.treeUri}`}
      data-testid={`${tree.treeUri}-options-button`}
      Icon={MenuMore}
      {...menuButtonProps}
      title={t('tree-import.tree.label')}
      onClick={(event) => onMenuClick(event, tree)}
    />
  )
}
